import { Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { dataHealthQuery } from '../relay/data-health-query';
import type { dataHealthQuery as DataHealthQuery } from '../relay/__generated__/dataHealthQuery.graphql';
import { DataHealthErrorBoundary } from './data-health-error';
import { DataHealthPage } from './data-health-page';
import { LoadingContent } from './loading-content';
import type { HealthReportView } from './data-health-view';

/**
 * Data -> Data health (pv-frontend#1079). Reads the admin `dataHealth` query (read fresh by the server,
 * so a reload always shows the table as it stands) and hands it to the presentational page. A failed
 * query shows the error card rather than a blank page.
 */
export function DataHealthScreen() {
    return (
        <DataHealthErrorBoundary>
            <Suspense fallback={<LoadingContent />}>
                <DataHealthResults />
            </Suspense>
        </DataHealthErrorBoundary>
    );
}

function DataHealthResults() {
    const { dataHealth } = useLazyLoadQuery<DataHealthQuery>(
        dataHealthQuery,
        {},
        { fetchPolicy: 'network-only' },
    );
    const report: HealthReportView = {
        generatedAt: dataHealth.generatedAt,
        lastWrittenAt: dataHealth.lastWrittenAt ?? null,
        liveTier: dataHealth.liveTier ?? null,
        counts: dataHealth.counts,
        domains: dataHealth.domains,
        scheduler: dataHealth.scheduler ?? null,
        rows: dataHealth.rows,
        dueDrops: dataHealth.dueDrops,
        expiring: dataHealth.expiring,
        nextExpiry: dataHealth.nextExpiry ?? null,
    };
    return <DataHealthPage report={report} />;
}
